
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30091',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30091",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54258",
  "head-dlb": "static-1.4935",
  "hs-test-utils": "static-1.7910",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11353",
  "I18n": "static-7.1603",
  "quartz": "static-1.6867",
  "quartz-config": "static-1.645",
  "quartz-core": "static-1.6086",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.769",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54245",
  "feedback-utils": "static-1.54249",
  "forms-embed-utils-lib": "static-1.4361",
  "forms-utils-lib": "static-1.12389",
  "foundations-assets": "static-1.4747",
  "foundations-components": "static-1.7721",
  "foundations-theming": "static-1.4312",
  "hub-http": "static-1.6118",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11661",
  "icons": "static-2.639",
  "immutable": "static-2.76",
  "quick-fetch": "static-1.3834",
  "raven": "static-3.5826",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16554",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5266",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57189",
  "transmute": "static-2.85",
  "ui-images": "static-2.1129",
  "UIComponents": "static-3.8300",
  "hs-promise-rejection-tracking": "static-1.5487",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6133",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9522",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3324",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3144",
  "quartz-webpack": "static-1.3091",
  "foundations-theming-specialty": "static-1.2028",
  "property-description-translator": "static-1.3752",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3021",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4223",
  "jasmine-runner": "static-1.6368",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "hubspotter-http": "static-1.4570",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.542",
  "quartz-head": "static-1.532",
  "quartz-i18n": "static-1.542",
  "quartz-routing": "static-1.297",
  "quartz-test": "static-1.542",
  "quartz-tracking": "static-1.246",
  "ui-fonts": "static-1.615",
  "usage-tracker-container": "static-1.7225",
  "usage-tracker-core": "static-1.7085",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7149",
  "reference-resolvers": "static-1.8066",
  "sanitize-text": "static-1.8044",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10273",
  "sanitize": "static-1.4372",
  "outpost": "static-1.4094",
  "rpc-client-utils": "static-1.4543",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3990",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9329",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1530",
  "bend-plugin-foundations-theming": "static-1.2795",
  "foundations-theming-base": "static-1.3297",
  "stylex": "static-1.30",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8682",
  "atom": "static-1.4970",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7602",
  "ContentUtils": "static-1.68044",
  "data-token-picker": "static-1.16226",
  "file-manager-components": "static-1.23299",
  "FileManagerCore": "static-1.38798",
  "FileManagerLib": "static-1.38939",
  "frontend-preferences-client": "static-1.7823",
  "hub-http-contrib": "static-1.2942",
  "interframe": "static-3.4662",
  "layout-dnd-components": "static-1.12248",
  "layout-dnd-utils": "static-1.11223",
  "property-translator": "static-1.5307",
  "react-codemirror": "static-1.10523",
  "react-colorpicker": "static-2.10108",
  "reference-resolvers-lite": "static-1.7988",
  "rich-text-lib": "static-1.19655",
  "tinymce-data": "static-1.40160",
  "tinymce-themes": "static-1.56045",
  "ui-addon-emoji-picker": "static-1.9786",
  "ui-addon-sales-email": "static-1.5110",
  "ui-brand-identity-lib": "static-1.14786",
  "bender-build-tools": "static-1.3063",
  "hub-http-shared-msw-handlers": "static-1.9731",
  "hubspotter-http-shared-msw-handlers": "static-1.9729",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4921",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1780",
  "chatspot-core": "static-1.20806",
  "copilot-toolkit": "static-1.10844",
  "data-fetching-client": "static-1.9574",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4668",
  "ui-addon-video-player": "static-1.8595",
  "ui-coaching-tips": "static-1.28257",
  "usage-tracker": "static-1.7235",
  "cms-field-types": "static-1.4708",
  "content-icons-ui": "static-1.2202",
  "integrations-lib": "static-1.15783",
  "customer-data-objects": "static-1.7558",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4550",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4052",
  "ui-addon-iframeable": "static-1.8948",
  "video-components-external": "static-1.10949",
  "video-data-lib": "static-1.34607",
  "audio-components": "static-1.5763",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29106",
  "FileManagerImages": "static-1.36450",
  "foundations-components-legacy": "static-1.746",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8835",
  "urlinator": "static-1.4431",
  "video-components": "static-1.12952",
  "video-embed": "static-1.35441",
  "ts-schema": "static-1.3996",
  "ContentData": "static-1.68119",
  "layout-data-lib": "static-1.9548",
  "react-dnd-compat": "static-1.4517",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1451",
  "external-options-client-types": "static-1.4076",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6774",
  "hs-promise-utils": "static-1.5493",
  "inbound-db-properties-service-client": "static-1.3764",
  "NamespacedHubStyle": "static-2.8987",
  "growth-onboarding-confetti": "static-1.2970",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11046",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5492",
  "magpie-types": "static-1.4952",
  "simple-logging-lib": "static-1.2950",
  "growth-onboarding-feedback-components": "static-1.6481",
  "flux-actions": "static-1.325",
  "hubspot-apollo-client": "static-1.4777",
  "integrations-error-boundary-lib": "static-1.13198",
  "integrations-tracking-lib": "static-1.5495",
  "laboratory-lib": "static-3.7058",
  "native-integrations-shared-strings": "static-1.7685",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10046",
  "unified-auth": "static-1.349",
  "navigation-messaging": "static-1.6980",
  "content-media-composition-data-lib": "static-1.11906",
  "content-media-compositions": "static-2.15913",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18746",
  "unified-auth-core-lib": "static-1.630",
  "social-insights-client-types": "static-1.21783",
  "advanced-menus-core": "static-1.14971",
  "advanced-menus-lib": "static-1.11933",
  "ExportDialog": "static-6.10289",
  "ui-memberships-settings-lib": "static-1.33763",
  "conditional-properties-service-client": "static-1.3715",
  "crm-pipelines-api-client-types": "static-1.4060",
  "framework-builder-read-service-client": "static-1.3926",
  "framework-data-schema-quick-fetch": "static-1.6679",
  "inbound-db-meta-service-client": "static-1.3507",
  "multi-currency-client-types": "static-1.3608",
  "persist-promise": "static-1.3608",
  "foundations-components-test-utils": "static-1.5204",
  "reactive-lib": "static-1.623",
  "hubspot-apollo-cache": "static-1.236",
  "universal-page-editor-lib": "static-1.2906",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3633",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14970",
  "simple-menus-lib": "static-1.16487",
  "crm-record-cards-service-types": "static-1.3528",
  "location-customization-utils-lib": "static-1.8919",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30091",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54258",
  "head-dlb": "/head-dlb/static-1.4935",
  "hs-test-utils": "/hs-test-utils/static-1.7910",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11353",
  "I18n": "/I18n/static-7.1603",
  "quartz": "/quartz/static-1.6867",
  "quartz-config": "/quartz-config/static-1.645",
  "quartz-core": "/quartz-core/static-1.6086",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.769",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54245",
  "feedback-utils": "/feedback-utils/static-1.54249",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4361",
  "forms-utils-lib": "/forms-utils-lib/static-1.12389",
  "foundations-assets": "/foundations-assets/static-1.4747",
  "foundations-components": "/foundations-components/static-1.7721",
  "foundations-theming": "/foundations-theming/static-1.4312",
  "hub-http": "/hub-http/static-1.6118",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11661",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.76",
  "quick-fetch": "/quick-fetch/static-1.3834",
  "raven": "/raven/static-3.5826",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16554",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5266",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57189",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1129",
  "UIComponents": "/UIComponents/static-3.8300",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5487",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6133",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9522",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3324",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3144",
  "quartz-webpack": "/quartz-webpack/static-1.3091",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2028",
  "property-description-translator": "/property-description-translator/static-1.3752",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3021",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4223",
  "jasmine-runner": "/jasmine-runner/static-1.6368",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "hubspotter-http": "/hubspotter-http/static-1.4570",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.542",
  "quartz-head": "/quartz-head/static-1.532",
  "quartz-i18n": "/quartz-i18n/static-1.542",
  "quartz-routing": "/quartz-routing/static-1.297",
  "quartz-test": "/quartz-test/static-1.542",
  "quartz-tracking": "/quartz-tracking/static-1.246",
  "ui-fonts": "/ui-fonts/static-1.615",
  "usage-tracker-container": "/usage-tracker-container/static-1.7225",
  "usage-tracker-core": "/usage-tracker-core/static-1.7085",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7149",
  "reference-resolvers": "/reference-resolvers/static-1.8066",
  "sanitize-text": "/sanitize-text/static-1.8044",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10273",
  "sanitize": "/sanitize/static-1.4372",
  "outpost": "/outpost/static-1.4094",
  "rpc-client-utils": "/rpc-client-utils/static-1.4543",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3990",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9329",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1530",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2795",
  "foundations-theming-base": "/foundations-theming-base/static-1.3297",
  "stylex": "/stylex/static-1.30",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8682",
  "atom": "/atom/static-1.4970",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7602",
  "ContentUtils": "/ContentUtils/static-1.68044",
  "data-token-picker": "/data-token-picker/static-1.16226",
  "file-manager-components": "/file-manager-components/static-1.23299",
  "FileManagerCore": "/FileManagerCore/static-1.38798",
  "FileManagerLib": "/FileManagerLib/static-1.38939",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7823",
  "hub-http-contrib": "/hub-http-contrib/static-1.2942",
  "interframe": "/interframe/static-3.4662",
  "layout-dnd-components": "/layout-dnd-components/static-1.12248",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11223",
  "property-translator": "/property-translator/static-1.5307",
  "react-codemirror": "/react-codemirror/static-1.10523",
  "react-colorpicker": "/react-colorpicker/static-2.10108",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7988",
  "rich-text-lib": "/rich-text-lib/static-1.19655",
  "tinymce-data": "/tinymce-data/static-1.40160",
  "tinymce-themes": "/tinymce-themes/static-1.56045",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9786",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5110",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14786",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9731",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9729",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4921",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1780",
  "chatspot-core": "/chatspot-core/static-1.20806",
  "copilot-toolkit": "/copilot-toolkit/static-1.10844",
  "data-fetching-client": "/data-fetching-client/static-1.9574",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4668",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8595",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28257",
  "usage-tracker": "/usage-tracker/static-1.7235",
  "cms-field-types": "/cms-field-types/static-1.4708",
  "content-icons-ui": "/content-icons-ui/static-1.2202",
  "integrations-lib": "/integrations-lib/static-1.15783",
  "customer-data-objects": "/customer-data-objects/static-1.7558",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4550",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4052",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8948",
  "video-components-external": "/video-components-external/static-1.10949",
  "video-data-lib": "/video-data-lib/static-1.34607",
  "audio-components": "/audio-components/static-1.5763",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29106",
  "FileManagerImages": "/FileManagerImages/static-1.36450",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.746",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8835",
  "urlinator": "/urlinator/static-1.4431",
  "video-components": "/video-components/static-1.12952",
  "video-embed": "/video-embed/static-1.35441",
  "ts-schema": "/ts-schema/static-1.3996",
  "ContentData": "/ContentData/static-1.68119",
  "layout-data-lib": "/layout-data-lib/static-1.9548",
  "react-dnd-compat": "/react-dnd-compat/static-1.4517",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1451",
  "external-options-client-types": "/external-options-client-types/static-1.4076",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6774",
  "hs-promise-utils": "/hs-promise-utils/static-1.5493",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3764",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8987",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2970",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11046",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5492",
  "magpie-types": "/magpie-types/static-1.4952",
  "simple-logging-lib": "/simple-logging-lib/static-1.2950",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6481",
  "flux-actions": "/flux-actions/static-1.325",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4777",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13198",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5495",
  "laboratory-lib": "/laboratory-lib/static-3.7058",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7685",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10046",
  "unified-auth": "/unified-auth/static-1.349",
  "navigation-messaging": "/navigation-messaging/static-1.6980",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11906",
  "content-media-compositions": "/content-media-compositions/static-2.15913",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18746",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.630",
  "social-insights-client-types": "/social-insights-client-types/static-1.21783",
  "advanced-menus-core": "/advanced-menus-core/static-1.14971",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11933",
  "ExportDialog": "/ExportDialog/static-6.10289",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33763",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3715",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4060",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3926",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6679",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3507",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3608",
  "persist-promise": "/persist-promise/static-1.3608",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5204",
  "reactive-lib": "/reactive-lib/static-1.623",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.236",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2906",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3633",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14970",
  "simple-menus-lib": "/simple-menus-lib/static-1.16487",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3528",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8919",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
